var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('img',{staticClass:"image",attrs:{"src":_vm.logoutUrl,"height":"1","width":"1"},on:{"load":_vm.onFinish,"error":_vm.onFinish}})])}
var staticRenderFns = []

export { render, staticRenderFns }